<section
    class="modal__details fade-in"
    [ngClass]="{
        'modal-mobile': isMobile,
        'modal-mobile-enter': isMobile && !isClosing,
        'modal-mobile-exit': isMobile && isClosing,
    }"
>
    <div class="header" #header *ngIf="!isMobile">
        <div class="modal__title" *ngIf="!loadingList">
            Материал: {{ reseachChild[0].specimenText ?? '' }}
            <div
                *ngIf="!isMobile"
                class="research-child-item__save"
                (click)="
                    goPdf(
                        pickedResearch?.researchId,
                        $event,
                        pickedResearch?.extResults,
                        pickedResearch?.internalOrder
                    )
                "
            >
                <mat-icon
                    *ngIf="!isPdfLoading(pickedResearch?.researchId)"
                    svgIcon="print"
                    class="cls-btn-print cls-btn-icon-print-custom"
                    alt="PdfLoading"
                ></mat-icon>
                <div
                    class="loader"
                    *ngIf="isPdfLoading(pickedResearch?.researchId)"
                ></div>
            </div>
            <div
                *ngIf="isMobile"
                class="research-child-item__save"
                (click)="
                    goPdf(
                        pickedResearch?.researchId,
                        $event,
                        pickedResearch?.extResults,
                        pickedResearch?.internalOrder
                    )
                "
            >
                <mat-icon
                    *ngIf="!isPdfLoading(pickedResearch?.researchId)"
                    svgIcon="print"
                    class="cls-btn-print cls-btn-icon-print-custom"
                    alt="PdfLoading"
                ></mat-icon>
                <div
                    class="loader"
                    *ngIf="isPdfLoading(pickedResearch?.researchId)"
                ></div>
            </div>
        </div>

        <button
            class="modal__close"
            (click)="closeModal($event)"
            *ngIf="!isMobile"
        ></button>
    </div>
    <div class="modal__body" [class.closing]="isClosing" #modalBody>
        <div *ngIf="loadingList && !isMobile" class="loading-container">
            <loader type="page" message="Загружаем результаты..."></loader>
        </div>
        <div *ngIf="loadingList && isMobile" class="loader-mobile"></div>
        <div
            *ngIf="!reseachChild.length && !loadingList"
            class="result-is-empty"
        >
            Данный результат вы можете получить в медицинской организации
        </div>

        <ng-container *ngIf="isMobile" class="mobile-research-blocks">
            <ng-container *ngFor="let block of researchBlocks">
                <ng-container *ngFor="let item of block.items; let i = index">
                    <div class="mobile-result-item">
                        <div
                            class="mobile-research__title"
                            *ngIf="i === 0 && block.title"
                            [innerHTML]="block.title"
                        ></div>

                        <ng-container
                            *ngIf="
                                item.cleanTextLength > 20;
                                then mobileLongResult;
                                else mobileShortResult
                            "
                        ></ng-container>

                        <ng-template #mobileLongResult>
                            <div class="results__long">
                                <div class="mobile-result-header">
                                    <div
                                        class="mobile-measure"
                                        [innerHTML]="item.safeMeasur"
                                    ></div>
                                    <div
                                        class="mobile-date"
                                        [innerHTML]="item.resultDate"
                                    ></div>
                                </div>

                                <div
                                    class="mobile-text"
                                    [innerHTML]="item.safeText"
                                ></div>
                            </div>
                            <div
                                class="results__long__measure"
                                *ngIf="item.notes.length > 2"
                                [innerHTML]="item.safeNotes"
                            ></div>
                            <div
                                class="results__long__measure"
                                [innerHTML]="item.safeNormNote"
                            ></div>
                        </ng-template>

                        <ng-template #mobileShortResult>
                            <div class="mobile-result-row">
                                <div
                                    class="mobile-table-header"
                                    *ngIf="block.showHeader"
                                >
                                    <div
                                        class="mobile-indicator-name"
                                        [innerHTML]="item.safeMeasur"
                                    ></div>

                                    <div class="mobile-date">
                                        <div class="mobile-status">
                                            <img
                                                *ngIf="item.dist.trim() !== ''"
                                                [ngClass]="{
                                                    rotate: isRotate(item.dist),
                                                }"
                                                src="./assets/images/laboratory/result-toggle.png"
                                                alt="arrow"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mobile-result-content">
                                    <div class="mobile-indicator">
                                        <div class="mobile-indicator-desc">
                                            <div>Результат</div>
                                            <div>Норма</div>
                                        </div>

                                        <div class="mobile-result-value">
                                            <div
                                                class="mobile-value"
                                                [ngClass]="{
                                                    'mobile-warning':
                                                        item.dist.trim(),
                                                }"
                                            >
                                                <div
                                                    [innerHTML]="item.safeText"
                                                ></div>
                                                <div
                                                    class="mobile-unit"
                                                    [innerHTML]="item.safeUnit"
                                                ></div>
                                            </div>

                                            <div
                                                class="mobile-result-details"
                                                [innerHTML]="item.safeNorm"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="results__long__measure"
                                *ngIf="item.notes.length > 2"
                                [innerHTML]="item.safeNotes"
                            ></div>
                            <div
                                class="results__long__measure"
                                [innerHTML]="item.safeNormNote"
                            ></div>
                        </ng-template>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!isMobile">
            <ng-container *ngFor="let block of researchBlocks">
                <div class="research-block">
                    <div class="research__title">
                        <span *ngIf="block.title" [innerHTML]="block.title">
                        </span>
                    </div>

                    <div class="description" *ngIf="block.showHeader">
                        <div
                            class="results__description-left results__description-title"
                        >
                            <div>Откл.</div>
                            <div>Показатель</div>
                        </div>
                        <div class="results__description-right">
                            <div>Результат</div>
                            <div>Норма</div>
                            <div>Дата</div>
                        </div>
                    </div>

                    <ng-container
                        *ngFor="let item of block.items; let i = index"
                    >
                        <div
                            class="results"
                            [ngClass]="{
                                'long-result': item.cleanTextLength > 20,
                            }"
                        >
                            <ng-container
                                *ngIf="
                                    item.cleanTextLength > 20;
                                    then LongResult;
                                    else shortResult
                                "
                            ></ng-container>

                            <ng-template #LongResult>
                                <div
                                    class="results__long-title"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                    *ngIf="
                                        item.measur.toLowerCase() !==
                                        'заключение'
                                    "
                                >
                                    <div></div>
                                    <div
                                        class="results__long__measure"
                                        [innerHTML]="item.safeMeasur"
                                    ></div>
                                    <div
                                        class="mobile-result-details"
                                        [innerHTML]="item.safeNorm"
                                    ></div>
                                    <div
                                        class="results__long__date"
                                        [innerHTML]="item.resultDate"
                                    ></div>
                                </div>
                                <div
                                    [class]="
                                        item.measur.toLowerCase() ===
                                        'заключение'
                                            ? 'results__long__measure'
                                            : 'longtext'
                                    "
                                    [innerHTML]="item.safeText"
                                ></div>
                                <div
                                    class="results__long__measure"
                                    [innerHTML]="item.safeNormNote"
                                ></div>
                            </ng-template>

                            <ng-template #shortResult>
                                <div
                                    class="results__description-left"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                >
                                    <div>
                                        <img
                                            *ngIf="item.dist.trim() !== ''"
                                            [ngClass]="{
                                                rotate: isRotate(item.dist),
                                            }"
                                            src="./assets/images/laboratory/result-toggle.png"
                                            alt="arrow"
                                        />
                                    </div>
                                    <div [innerHTML]="item.safeMeasur"></div>
                                </div>
                                <div
                                    class="results__description-right items-start"
                                    [ngClass]="{ 'bgc-even': i % 2 !== 0 }"
                                >
                                    <div>
                                        <span
                                            class="value"
                                            [innerHTML]="item.safeText"
                                            [ngClass]="{
                                                warning: item.dist.trim(),
                                            }"
                                        ></span>
                                        <span [innerHTML]="item.safeUnit">
                                        </span>
                                    </div>
                                    <div [innerHTML]="item.safeNorm"></div>

                                    <div [innerHTML]="item.resultDate"></div>
                                </div>
                                <div
                                    class="results__long__measure"
                                    [innerHTML]="item.safeNormNote"
                                ></div>
                            </ng-template>
                        </div>
                        <div
                            class="results__long__measure"
                            *ngIf="item.notes.length > 2"
                            [innerHTML]="item.safeNotes"
                        ></div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
</section>
